<template>
    <div class="c-footer">
        <div class="item" @click="phone">
            <img class="icon" alt="" src="@/assets/wap/icon/phone.png">
            Call sales
        </div>
        <div class="item" @click="contact">
            <img class="icon" alt="" src="@/assets/wap/icon/contact.png">
            Contact Us
        </div>
        <ContactUs :show="showContactUs" @close="closeContact"></ContactUs>
    </div>
</template>
<script>
import ContactUs from "../common/ContactUs.vue";
export default {
    name: 'FooterWAP',
    components: {
        ContactUs
    },
    data() {
        return {
            showContactUs: false
        }
    },
    methods: {
        phone() {
            this.$gioAction('navbottomclick_hk', { 'jingtaititle_hk': 'Call sales' });
            window.location.href = 'tel:29693116';
        },
        contact() {
            this.$gioAction('navbottomclick_hk', { 'jingtaititle_hk': 'Contact Us' });
            this.showContactUs = true;
        },
        closeContact() {
            this.showContactUs = false;
        }
    }
}
</script>
<style lang="scss" scoped>
.c-footer {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 13.67vw;
    z-index: 10;

    display: flex;
    justify-content: space-between;
    align-items: center;
    .item {
        width: 49.8%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 3.73vw;
        color: #fff;
        background: linear-gradient( 180deg, #0076CE 0%, #085A97 100%);
        .icon {
            height: 5.47vw;
            width: auto;
            margin-right: 1.87vw;
        }
    }
}
</style>